module.exports = __webpack_public_path__ + "left.png?74e06c7717f51ecdf4e9e19855b28248";